// @flow

import type { SegmentEventName, SegmentEventProps } from './segment-events';
import { callSegment } from './segment.js';

// eslint-disable-next-line import/prefer-default-export
export const trackEvent = (event: SegmentEventName, properties?: SegmentEventProps) => {
  callSegment(segment => segment.track(event, properties));
};
